import { render, staticRenderFns } from "./OwnerPatientListPopup.vue?vue&type=template&id=0c7f474b&scoped=true&"
import script from "./OwnerPatientListPopup.vue?vue&type=script&lang=js&"
export * from "./OwnerPatientListPopup.vue?vue&type=script&lang=js&"
import style0 from "./OwnerPatientListPopup.vue?vue&type=style&index=0&id=0c7f474b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7f474b",
  null
  
)

export default component.exports